import CompanyInfoTitle from "./CompanyInfoTitle/CompanyInfoTitle";
import CompanyHightlights from "./CompanyHighlights/CompanyHighlights";
import ContactBadges from "./ContactBadges/ContactBadges";
import GlobalPresence from "./GlobalPresence/GlobalPresence";
import CoreCompetencies from "./CoreCompetencies/CoreCompetencies";
import InnovationInitiatives from "./InnovationInitiatives/InnovationInitiatives";
import KeyMilestones from "./KeyMilestones/KeyMilestones";
import MyProfile from "./MyProfile/MyProfile";

const Profile = () => {
    return (
        <div className="Profile">
            <div className="profileCard">
                <div className="profileCardColumn">
                    <div className="companyInfo">
                        <CompanyInfoTitle />
                        <CompanyHightlights />
                        <ContactBadges />
                        <GlobalPresence />
                        <CoreCompetencies />
                    </div>
                </div>
                <div className="profileCardDivider"></div>
                <div className="profileCardColumn">
                    <InnovationInitiatives />
                    <KeyMilestones />
                    <MyProfile />
                </div>
            </div>
        </div>
    );
};

export default Profile;
